import Backbone from 'backbone'
import _ from 'lodash'
import moment from 'moment'
import FormView from 'scoreboard/components/form-view'
import WeightDateTable from './weight-date-table'
import template from './weight-date-ranges-form.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'


/**
 * Given a weight date range, finds the weight for the given period
 */
function weightInDateRange(dateRange, period) {
	return Number(_.find(dateRange, range => {
		if (_.isNil(range.start)) {
			if (_.isNil(range.end)) {
				return true  //only one weight, use as current
			}
			return period.end.isSameOrBefore(moment(range.end), 'day')
		} else if (_.isNil(range.end)) {
			return period.end.isSameOrAfter(moment(range.start), 'day')
		} else {
			return period.end.isBetween(moment(range.start),
				moment(range.end), 'day', '[]')
		}
	}).weight)
}


const WeightDateRanges = Backbone.View.extend({

	tagName: 'form',

	className: 'weight-date-ranges-form',

	initialize: function(options = {}) {
		this.opts = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
	},

	render: function() {
		let weightNode = this.opts.weightNode
		// render template
		this.$el.html(template(weightNode))

		_.invoke(this.table, 'remove')
		this.table = new WeightDateTable({
			el: this.$('.panel-with-table'),
			formView: this.formView,
			weightNode
		}).render()
		this.formView.start()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	submit: function(e) {
		e.preventDefault()
		this.trigger('done', this.table.gather())
	},

	remove: function() {
		_.invokeMap([this.formView, this.table,
			this.covertButtonTooltips], 'remove')
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})

_.extend(WeightDateRanges, {
	weightInDateRange
})
export default WeightDateRanges
export { weightInDateRange }

WeightDateRanges.__filename__ = 'scorecards/edit/weight-date-ranges-form.js'
